
























































































































































































import { clientFormComposition } from '@/compositions/clientForm'
import { defineComponent, PropType, ref } from '@vue/composition-api'
import ClientDialog from './Remittance/ClientDialog.vue'
import ClientAutocomplete from './Remittance/ClientAutocomplete.vue'
import PhoneTextField from '@/components/PhoneTextField.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import CreateCityDialog from '@/components/CreateCityDialog.vue'
import ActionButton from '@/components/ActionButton.vue'
import { Client } from '@/api/Agency/agency.interface'
import { computed } from '@vue/composition-api'

export default defineComponent({
  components: {
    ClientDialog,
    ClientAutocomplete,
    PhoneTextField,
    Autocomplete,
    CreateCityDialog,
    ActionButton,
  },
  props: {
    mlc: Boolean,
    mlx: Boolean,
    ust: Boolean,
    client: Object as PropType<Client>,
  },
  setup: props => {
    const clientComposition = clientFormComposition('ORIGIN', props)
    const { onNext } = clientComposition

    const request_signature = ref(false)
    const defaultCountry = { country: 'US', callingCode: '1' }

    const newNext = async () => {
      const client = await onNext()
      if (client) {
        return {
          client_origin: client,
          request_signature: request_signature.value,
        }
      }
      return false
    }

    const isSpecialRemittance = computed(() => {
      return props.mlx || props.ust
    })

    return {
      ...clientComposition,
      onNext: newNext,
      defaultCountry,
      request_signature,
      isSpecialRemittance,
    }
  },
  methods: {
    idRule(v: string) {
      if (!v.length) return true
      if (v.length < 5) return this.$t('validation.foreign_id')
      return true
    },
  },
})
